import {clsx} from 'clsx';
import React, {useCallback} from 'react';

import {usePanelSearchDebouncedContext} from '../../state/panelbank/PanelSearchContextProvider';
import {type PlotFontSize} from '../../util/plotHelpers/plotFontSize';
import {TruncateTextTooltip} from '../common/TruncateText/TruncateTextTooltip';
import {TruncationType} from '../common/TruncateText/TruncateTextTypes';
import {useIsFullScreenPanel} from '../Panel/hooks/useIsFullScreenPanel';
import {usePanelContext} from '../Panel/PanelContextProvider';
import {PanelPopupMode} from '../Panel/types';

interface PanelTitleProps {
  title: string;
  fontSize?: PlotFontSize | 'auto';
  disallowSelect?: boolean;
}

export const PanelTitle: React.FC<PanelTitleProps> = ({
  title,
  fontSize,
  disallowSelect,
}) => {
  const {makeHighlightSearchTitle} = usePanelSearchDebouncedContext();
  const {isFullScreen} = useIsFullScreenPanel();
  const {setPanelPopupMode} = usePanelContext();

  const handleClick = useCallback(() => {
    setPanelPopupMode(PanelPopupMode.EDIT);
  }, [setPanelPopupMode]);

  return (
    <TruncateTextTooltip
      data-dd-action-name="Panel title"
      className={clsx('PanelTitle', fontSize, {
        'select-none': disallowSelect,
      })}
      truncationType={TruncationType.Middle}
      fullText={title}
      highlight={isFullScreen ? undefined : makeHighlightSearchTitle}
      onClick={handleClick}
      noLink>
      title
    </TruncateTextTooltip>
  );
};
